import { useContext, useEffect, useState } from 'react';
import useConversationParticipants from './useConversationParticipants';
import { ConversationsListContext } from '../providers/ConversationParticipantsProvider';
import useMembers from '@hooks/useMembers';

const useCurrentParticipantMember = conversation => {
    const [member, setMember] = useState();
    const { participant } = useConversationParticipants(conversation);
    const { allParticipantIdentities } = useContext(ConversationsListContext);
    const { members } = useMembers(allParticipantIdentities);

    useEffect(() => {
        if (!participant || !members) return;
        const foundMember = members.find(m => m.id === participant.state.identity);
        setMember(foundMember);
    }, [members, participant]);

    return { currentParticipantMember: member };
};

export default useCurrentParticipantMember;
